import {
	LeaderUserWithoutSensitive,
	UserWithoutSensitive,
} from '@reach/interfaces/user/user.interface';
import { UserInPing } from '@reach/interfaces/user/user-in-ping';

import { ClientUser } from '../types/user';

export interface UserTransformerOptions {
	impersonating?: boolean;
}

const getUrlWithQueryParam = (givenUrl: string | null): string | null => {
	if (!givenUrl) {
		return null;
	}

	try {
		const url = new URL(givenUrl);
		url.searchParams.set('t', `${Date.now()}`);
		return url.href;
	} catch (error) {
		return null;
	}
};

export function userTransformer(
	user: (UserWithoutSensitive | UserInPing) & { leader?: LeaderUserWithoutSensitive },
	options?: UserTransformerOptions
): ClientUser {
	const impersonating = options?.impersonating || false;
	const featureFlags = user.leader?.userFeatureFlags || user.userFeatureFlags;

	const thumbnailUrl = getUrlWithQueryParam(user.thumbnailUrl ?? null);
	const imageUrl = getUrlWithQueryParam(user.imageUrl ?? null);

	return {
		_raw: { ...user },
		id: user.privateId,
		username: user.username,
		type: user.type,
		impersonating,
		registerMethod: user.registerMethod,
		featureFlags,
		adminLevel: user.adminFeatureFlags,
		thumbnailUrl,
		imageUrl,
		email: user.email,
		emailVerified: user.emailVerified,
		fullName: user.fullName,
		firstName: user.firstName,
		country: user.country,
		gender: user.gender,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-unnecessary-condition
		activatedAt: new Date(user.activatedAt!)?.valueOf(),
		followingTeamLeader: user.leader?.privateId !== user.privateId,
	};
}
